module.exports = __webpack_public_path__ + "img/landscape-7704393_1280.0ee3f59d.jpg";